<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-price-level-single-select-edit-control formControlName="priceLevel"
                                                                    [(ngModel)]="model.data.priceLevel"
                                                                    [allowClearSelectionOption]="false"></wbo-price-level-single-select-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-single-select-edit-control [(ngModel)]="model.data.format"
                                                        [allowClearSelectionOption]="false"
                                                        [formControlName]="'format'">
                            <wbo-select-options>
                                <wbo-select-option [value]="'3 x 11'"
                                                   label="wbo.product-barcode-report.option.format.3x11"></wbo-select-option>
                                <wbo-select-option [value]="'5 x 13'"
                                                   label="wbo.product-barcode-report.option.format.5x13"></wbo-select-option>
                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <wbo-product-barcode-report-selection [editQty]="true"></wbo-product-barcode-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
